module.exports = __webpack_public_path__ + "img/car_5_vw.5a25e075.jpg";